// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__dTf11","connectButton":"Header_connectButton__+kfsx","addrWrapper":"Header_addrWrapper__yJ3F3"};